/**
 * @file index.js
 * @description Entry point of the application with dynamic manifest support.
 **/
import { resolveCompanyCode } from './utils/utils';

const initializeDynamicManifest = () => {
    const companyCode = resolveCompanyCode();

    const existingManifest = document.querySelector('link[rel="manifest"]');
    if (existingManifest) {
        existingManifest.remove();
    }

    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = companyCode
        ? `/manifest.webmanifest?companyCode=${companyCode}`
        : '/manifest.webmanifest';
    document.head.appendChild(manifestLink);

    console.log(`Dynamic manifest loaded for company: ${companyCode || 'none'}`);
};

initializeDynamicManifest();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
    SERVICE_WORKER_SCOPE,
    SERVICE_WORKER_URL,
} from './constants/serviceWorker';
// import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import { BrowserRouter } from 'react-router-dom';
import './global.scss';
import { AuthContextProvider } from './store/Contexts';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        </BrowserRouter>
    </React.StrictMode>,
);

//Service worker setup for Android PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(SERVICE_WORKER_URL, { scope: SERVICE_WORKER_SCOPE })
            .then(registration => {
                console.log('[pwa-sw] Registered successfully:', registration);
            })
            .catch(error => {
                console.error('[pwa-sw] Registration failed:', error);
            });
    });
}
